/**
 * 考核报表接口
 */

const prefix = '/dseWeb'
export default [
  // 分页查询
  { name: 'getMonthReportPage', url: `${prefix}/v1/op/month/page`, method: 'post' },

  // 保存/更新
  { name: 'updateMonthReport', url: `${prefix}/v1/op/month/update`, method: 'post' },

  // 导出
  { name: 'exportMonthReport', url: `${prefix}/v1/op/month/export`, method: 'post' },

  // 模板下载
  { name: 'downloadMonthReportTemplate', url: `${prefix}/v1/op/month/downloadTemplate`, method: 'post' },

  // 导入
  { name: 'importMonthReport', url: `${prefix}/v1/op/month/dataImport`, method: 'post' }
]
